module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Text-body-after-subhead ParaOverride-3"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-5"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgments"
    }
  }, [_vm._v("Preface to the Second Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-7"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part1"
    }
  }, [_vm._v("Part I: Class Struggle in the Land of Opportunity, 1865–1930")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter1"
    }
  }, [_vm._v("1.\tAre American Workers Different?")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter2"
    }
  }, [_vm._v("2.\tThe Peculiarities of American Capitalism\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-7"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: The Battle for Industrial Unions—The View from Below")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.\tThe Rise of the Labor Left, 1900–1930\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.\tDepression Decade: The Turning Point\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-7"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: The Employers Strike Back")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.\tFrom World War to Cold War\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.\tSocial Contract?")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-7"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV: One-Sided Class War")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.\tThe Employers’ Offensive\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.\tThe Neoliberal President Dismantles the New Deal\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.\tRule of the Neocons\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-7"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\tPart V: From George W. Bush to Donald J. Trump")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.\tManufactured on Wall Street: The Great Recession")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.\tThe Flashpoints of a New Resistance\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. \tThe Rogue President\t")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 66
// module chunks = 0